import { call, put, takeEvery } from "redux-saga/effects";
import { xepTkbChuanBiApi } from "../../../api/ke-hoach/xepTkbChuanBiApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eXepTkbChuanBiActionIds, IXepTkbChuanBiActionTypes } from "../../action-types/ke-hoach/IXepTkbChuanBiActions";
import { rootActions } from "../../actions/rootActions";

const mainAction = rootActions.keHoach.xepTkbChuanBi;

export function* xepTkbChuanBiSaga(): any {
    yield takeEvery(eXepTkbChuanBiActionIds.TAO_LAI_THEO_MON_START, taoLaiWorker);
    yield takeEvery(eXepTkbChuanBiActionIds.CAP_NHAT_SU_KIEN_START, capNhatSuKienWorker);
}

function* taoLaiWorker(action: IXepTkbChuanBiActionTypes): any {
    const payload = action.payload as { ids: number[], ky_dang_ky: number, reload: any };
    const res: IBaseRespone = yield call(xepTkbChuanBiApi.TaoLaiTheoMon, { id_kh_mons: payload.ids, ky_dang_ky: payload.ky_dang_ky });
    if (res.is_success) {
        yield put(mainAction.TAO_LAI_THEO_MON_SUCCESS(undefined));
        // Reload lưới — green-check is_da_tao_lop_tc (derived) tự cập nhật
        yield put(rootActions.keHoach.keHoachMon.LOAD_NHOMLOP_FULL_START(payload.reload));
    } else {
        yield put(mainAction.TAO_LAI_THEO_MON_ERROR(res.message ?? "Có lỗi"));
    }
}

function* capNhatSuKienWorker(action: IXepTkbChuanBiActionTypes): any {
    const payload = action.payload as { ids: number[], ky_dang_ky: number, reload: any };
    const res: IBaseRespone = yield call(xepTkbChuanBiApi.CapNhatSuKienTheoMon, { id_kh_mons: payload.ids, ky_dang_ky: payload.ky_dang_ky });
    if (res.is_success) {
        yield put(mainAction.CAP_NHAT_SU_KIEN_SUCCESS(undefined));
        yield put(rootActions.keHoach.keHoachMon.LOAD_NHOMLOP_FULL_START(payload.reload));
    } else {
        yield put(mainAction.CAP_NHAT_SU_KIEN_ERROR(res.message ?? "Có lỗi"));
    }
}
